
import HeartIcon from "@/components/marketAnalysis/icons/HeartIcon";
import HeartIconFilled from "@/components/marketAnalysis/icons/HeartIconFilled";
import NextIcon from "@/components/marketAnalysis/icons/NextIcon";
import UserTickIcon from "@/components/marketAnalysis/icons/UserTickIcon";

export default {
    name: 'FAQCard',

    components: {
        NextIcon,
        UserTickIcon,
        HeartIcon,
        HeartIconFilled,
    },

    props: {
        question: {
            type: Object,
            required: true
        },
        showLikeButton: {
            type: Boolean,
            default: true
        }
    },
    
    emits: ['like-toggle', 'click'],

    methods: {
        getUsersAskedText(count) {
            return `${count} ${count > 1 ? this.$t('pages.marketAnalysis.faq.usersAskedThis') : this.$t('pages.marketAnalysis.faq.userAskedThis')}`;
        },
        handleClickHeartIcon(event, id, isLiked) {
            event.stopPropagation();
            this.$emit('like-toggle', { id, isLiked });
        }
    }
}
